import { useEffect, useState } from 'react';

import { BaseFormInput } from '../../interfaces';
import { composeValidators } from '../helpers';

interface UseFormInputProps extends Pick<BaseFormInput, 'label' | 'validators' | 'description'> {
  required?: boolean;
  disabled?: boolean;
  name: string;
  validationKey?: string;
}

export const useFormInput = ({
  description,
  disabled = false,
  label,
  name,
  required = true,
  validators,
}: UseFormInputProps) => {
  // @NOTE hack to avoid error on validate property update
  // when input is no longer required
  // https://final-form.org/docs/react-final-form/types/FieldProps#validate
  // <Field ... data={{ validationKey }}>{() => ...}</Field>
  const [validationKey, setValidationKey] = useState<string>(`${name}-0`);

  const submitValidator = (required && validators?.submit) || undefined;
  const formatValidator = (!!validators?.format && validators.format) || [];

  const isRequired = required && !!submitValidator;
  const composed = [isRequired && submitValidator, ...formatValidator].filter(Boolean);
  const validate = !disabled && formatValidator ? composeValidators(...composed) : () => {};

  const texts = {
    hint: description && typeof description === 'function' ? description() : description,
    label: isRequired ? `${label} *` : label,
  };

  useEffect(() => {
    setValidationKey(`${name}-${required ? 1 : 0}`);
  }, [name, required]);

  return { id: name, texts, validate, validationKey };
};
